<template>
    <TextField
        :id="id"
        ref="field"
        v-model="inputVal"
        v-bind="$attrs"
        :required="required"
        :minlength="minlength"
        :maxlength="maxlength"
        :validations="validations"
        :disabled="disabled"
    >
        <template #label>
            <slot name="label">{{ $attrs.label }}</slot>
        </template>

        <template #message="messageProps">
            <slot name="message" :message="messageProps.message" />
        </template>
    </TextField>
</template>
<script>
    import { validEmail } from "@/util/validation"
    import FieldProxyMixin from "@/components/form/FieldProxyMixin.vue"

    export default {
        mixins: [FieldProxyMixin],

        props: {
            minlength: {
                type: [Number, String],
                default: null,
            },

            maxlength: {
                type: [Number, String],
                default: null,
            },
        },

        methods: {
            validationSource: function (target, field) {
                field.applyValidator(target, validEmail.id, validEmail)

                field.applyValidator(target, "blacklistedEmails", value => {
                    if (!value) return true
                    if (!this.getRemoteValidator()) return true
                    return this.getRemoteValidator()
                        .validate("email", { email: value })
                        .then(({ valid }) => valid)
                })
            },
            focus() {
                this.$refs.field.focus()
            },
            blur() {
                this.$refs.field.blur()
            },
        },
    }
</script>

<style lang="scss">
    .v-messages__message {
        line-height: 16px !important;
    }
</style>
